
export const randomBaseUrl = (min, max) => {
  var random = Math.floor(Math.random() * (+max - +min)) + +min
  var randomUrl

  switch (random) {
    case 0:
      randomUrl = process.env.VUE_APP_API_ENDPOINT
      break
    case 1:
      // randomUrl = process.env.VUE_APP_API_ENDPOINT1
      randomUrl = process.env.VUE_APP_API_ENDPOINT
      break
    case 2:
      // randomUrl = process.env.VUE_APP_API_ENDPOINT2
      randomUrl = process.env.VUE_APP_API_ENDPOINT
      break
    case 3:
      // randomUrl = process.env.VUE_APP_API_ENDPOINT3
      randomUrl = process.env.VUE_APP_API_ENDPOINT
      break
    case 4:
      // randomUrl = process.env.VUE_APP_API_ENDPOINT4
      randomUrl = process.env.VUE_APP_API_ENDPOINT
      break
    case 5:
      // randomUrl = process.env.VUE_APP_API_ENDPOINT5
      randomUrl = process.env.VUE_APP_API_ENDPOINT
      break
    default:
      randomUrl = process.env.VUE_APP_API_ENDPOINT
  }

  return randomUrl || process.env.VUE_APP_API_ENDPOINT
  // return process.env.VUE_APP_API_ENDPOINT
}
